import SingleSelectWithSearch from "../../../components/dropdown/SingleSelectWithSearch";
import TextInput from "../../../components/UIComponent/TextInput";
import ModalBasic from "../../component/ModalBasic";

export const table2Data = [];
export const table2ColDefs = [];

export const JournalVoucherTable = (props) => {
    return (
        <ModalBasic
            id="salaryBankTransfer"
            classParams="!w-[75%]"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}>
            <div className="input-fields p-[30px]">
                <div className="item-grp">
                    <span className="text-blue text-[16px] font-semibold">Journal voucher details</span>
                    <div className="item-inner grid grid-cols-3 gap-2.5 mt-[12px] mb-3">
                        <div className="input-grp">
                            <label>Voucher no</label>
                            <TextInput type="number" id="voucherNo" name="voucherNo" value={props.journalVoucherDetails.voucherNo} handleChange={(event) => props.handleChange(event, "voucherNo")} disabled />
                        </div>
                        <div className="input-grp">
                            <label>Date</label>
                            <TextInput type="date" id="date" name="date" value={props.journalVoucherDetails.date} handleChange={(event) => props.handleChange(event, "date")} className={props.validState?.error?.date !== undefined ? "error" : ""} />
                        </div>
                        {/* <div className="input-grp">
                            <label>Acc. sub head</label>
                            <SingleSelectWithSearch
                                drpIdentity={"aCCSubHeadList"}
                                optionArray={props.journalVoucherDetails.aCCSubHeadList}
                                value={props.journalVoucherDetails.idGeneralProduct}
                                searchText={props.journalVoucherDetails.productName}
                                handleChangeTest={props.handleSelectChange}
                                setFilterParameters={props.setFilterParameters}
                            // classParams={props.validState?.error?.idGeneralProduct !== undefined ? "error" : ""}
                            />
                        </div> */}
                    </div>
                    <div className="item-inner grid grid-cols-4 gap-2.5 mb-3 pb-[12px] border-b border-slate-200">
                        <div className="input-grp">
                            <label>From account</label>
                            <SingleSelectWithSearch
                                drpIdentity={"SelectAccount1"}
                                //optionArray={props.journalVoucherDetails.partyList}
                                optionArray={props.journalVoucherDetails.expenseBy}
                                value={props.journalVoucherDetails.expenseById1}
                                searchText={props.journalVoucherDetails.expenseByName1}
                                handleChangeTest={props.handleSelectChange}
                                setFilterParameters={props.setFilterParameters}
                            // classParams={props.validState?.error?.idPartyAccount !== undefined ? "error" : ""}
                            />
                            {/* <SingleSelectWithSearch
                                drpIdentity={"partyList"}
                                optionArray={props.journalVoucherDetails.partyList}
                                value={props.journalVoucherDetails.idPartyAccount}
                                searchText={props.journalVoucherDetails.partyACName}
                                handleChangeTest={props.handleSelectChange}
                                setFilterParameters={props.setFilterParameters}
                            // classParams={props.validState?.error?.idPartyAccount !== undefined ? "error" : ""}
                            /> */}
                        </div>
                        <div className="input-grp col-span-2">
                            <label>From party</label>
                            <SingleSelectWithSearch
                                drpIdentity={"partyList1"}
                                optionArray={props.journalVoucherDetails.partyList1}
                                value={props.journalVoucherDetails.idPartyAccount1}
                                searchText={props.journalVoucherDetails.partyACName1}
                                handleChangeTest={props.handleSelectChange}
                                setFilterParameters={props.setFilterParameters}
                                classParams={props.validState?.error?.idPartyAccount1 !== undefined ? "error" : ""}
                            />
                            {/* <SingleSelectWithSearch
                                drpIdentity={"partyList2"}
                                optionArray={props.journalVoucherDetails.partyList2}
                                value={props.journalVoucherDetails.idPartyAccount2}
                                searchText={props.journalVoucherDetails.partyACName2}
                                handleChangeTest={props.handleSelectChange}
                                setFilterParameters={props.setFilterParameters}
                                classParams={props.validState?.error?.idPartyAccount2 !== undefined ? "error" : ""}
                            /> */}
                            {/* <SingleSelectWithSearch id="selectSecParty" name="selectSecParty" value={props.journalVoucherDetails.selectSecParty} handleChangeTest={(event) => props.handleSelectChange(event, "selectSecParty")} className={props.validState?.error?.selectSecParty !== undefined ? "error" : ""} /> */}
                        </div>
                        {/* <div className="input-grp">
                            <label>Employee</label>
                            <SingleSelectWithSearch
                                drpIdentity={"employeeList"}
                                optionArray={props.journalVoucherDetails.employeeList}
                                value={props.journalVoucherDetails.idEmployee}
                                searchText={props.journalVoucherDetails.employeeName}
                                handleChangeTest={props.handleSelectChange}
                                setFilterParameters={props.setFilterParameters}
                                classParams={props.validState?.error?.idEmployee !== undefined ? "error" : ""}
                            />
                            
                        </div> */}
                        <div className="input-grp">
                            <label>Type</label>
                            <SingleSelectWithSearch
                                //id="type"
                                //name="type"
                                //value={props.types} 
                                drpIdentity={"fromAccountType"}
                                optionArray={props.journalVoucherDetails.types}
                                //handleChangeTest={(event) => props.handleSelectChange(event, "type")}
                                value={props.journalVoucherDetails.fromAccountTypeId1}
                                searchText={props.journalVoucherDetails.fromAccountTypeName1}
                                // classParams={props.validState?.error?.fromAccountTypeId !== undefined ? "error" : ""}
                                //setFilterParameters={props.setFilterParameters}
                                disabled={true}
                            />
                        </div>
                    </div>
                    <div className="item-inner grid grid-cols-4 gap-2.5 mb-2.5">
                        <div className="input-grp">
                            <label>To account</label>
                            <SingleSelectWithSearch
                                drpIdentity={"SelectAccount2"}
                                //optionArray={props.journalVoucherDetails.partyList}
                                optionArray={props.journalVoucherDetails.expenseBy}
                                value={props.journalVoucherDetails.expenseById2}
                                searchText={props.journalVoucherDetails.expenseByName2}
                                handleChangeTest={props.handleSelectChange}
                                setFilterParameters={props.setFilterParameters}
                            // classParams={props.validState?.error?.idPartyAccount !== undefined ? "error" : ""}
                            />
                            {/* <SingleSelectWithSearch id="selectParty" name="selectParty" value={props.journalVoucherDetails.selectParty} handleChangeTest={(event) => props.handleSelectChange(event, "selectParty")} className={props.validState?.error?.selectParty !== undefined ? "error" : ""} /> */}
                        </div>
                        <div className="input-grp col-span-2">
                            <label>To party</label>
                            <SingleSelectWithSearch
                                drpIdentity={"partyList2"}
                                optionArray={props.journalVoucherDetails.partyList2}
                                value={props.journalVoucherDetails.idPartyAccount2}
                                searchText={props.journalVoucherDetails.partyACName2}
                                handleChangeTest={props.handleSelectChange}
                                setFilterParameters={props.setFilterParameters}
                                classParams={props.validState?.error?.idPartyAccount2 !== undefined ? "error" : ""}
                            />

                        </div>
                        <div className="input-grp">
                            <label>Type</label>
                            <SingleSelectWithSearch
                                //id="type"
                                //name="type"
                                //value={props.types} 
                                drpIdentity={"selectBankType"}
                                optionArray={props.journalVoucherDetails.types}
                                //handleChangeTest={(event) => props.handleSelectChange(event, "type")}
                                value={props.journalVoucherDetails.fromAccountTypeId2}
                                searchText={props.journalVoucherDetails.fromAccountTypeName2}
                                // classParams={props.validState?.error?.selectBankTypeId !== undefined ? "error" : ""}
                                //setFilterParameters={props.setFilterParameters}
                                disabled={true}
                            />
                        </div>
                    </div>
                    {/* <div className="item-inner grid grid-cols-4 gap-2.5 mb-3">
                        <div className="input-grp">
                            <label>Select series</label>
                            <SingleSelectWithSearch
                                drpIdentity={"selectSeries"}
                                optionArray={props.journalVoucherDetails.seriesList}
                                value={props.journalVoucherDetails.idChequeBookMaster}
                                searchText={props.journalVoucherDetails.chequeBookSeries}
                                handleChangeTest={props.handleSelectChange}
                                classParams={props.validState?.error?.idChequeBookMaster !== undefined ? "error" : ""}
                                setFilterParameters={props.setFilterParameters}
                                disabled={props.journalVoucherDetails.expenseById1 > 0 && props.journalVoucherDetails.expenseById1 === 3 ? false : true}
                            />
                        </div>
                        <div className="input-grp">
                            <label>Cheque no</label>
                            <SingleSelectWithSearch
                                drpIdentity={"chequeNo"}
                                optionArray={props.journalVoucherDetails.chequeNoList}
                                value={props.journalVoucherDetails.idChequeBookDetails}
                                searchText={props.journalVoucherDetails.chequeNo}
                                handleChangeTest={props.handleSelectChange}
                                setFilterParameters={props.setFilterParameters}
                                disabled={props.journalVoucherDetails.expenseById1 > 0 && props.journalVoucherDetails.expenseById1 === 3 ? false : true}
                            />
                        </div>
                        <div className="input-grp">
                            <label>Cheque date</label>
                            <TextInput type="date" id="chequeDate" name="chequeDate" value={props.journalVoucherDetails.chequeDate} handleChange={(event) => props.handleChange(event, "chequeDate")} className={props.validState?.error?.chequeDate !== undefined ? "error" : ""}
                                disabled={props.journalVoucherDetails.expenseById1 > 0 && props.journalVoucherDetails.expenseById1 === 3 ? false : true} />
                        </div>
                        <div className="input-grp">
                            <label>Reference no</label>
                            <TextInput type="text" id="refNo" name="refNo" value={props.journalVoucherDetails.refNo} handleChange={(event) => props.handleChange(event, "refNo")} className={props.validState?.error?.refNo !== undefined ? "error" : ""} />
                        </div>
                    </div> */}
                    <div className="item-inner grid grid-cols-4 gap-2.5 mb-3">
                        {/* <div className="input-grp">
                            <label>Tax type</label>
                            <SingleSelectWithSearch
                                drpIdentity={"taxtTypeList"}
                                optionArray={props.journalVoucherDetails.taxtTypeList}
                                value={props.journalVoucherDetails.idTaxtType}
                                searchText={props.journalVoucherDetails.taxtTypeName}
                                handleChangeTest={props.handleSelectChange}
                                setFilterParameters={props.setFilterParameters}
                                classParams={props.validState?.error?.idTaxtType !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className="input-grp">
                            <label>Tax group</label>
                            <SingleSelectWithSearch
                                drpIdentity={"TaxtStructureList"}
                                optionArray={props.journalVoucherDetails.taxtStructureList}
                                value={props.journalVoucherDetails.idTaxStructure}
                                searchText={props.journalVoucherDetails.taxStructureName}
                                handleChangeTest={props.handleSelectChange}
                                setFilterParameters={props.setFilterParameters}
                                classParams={props.validState?.error?.idTaxStructure !== undefined ? "error" : ""}
                            />
                        </div> */}
                        <div className="input-grp">
                            <label>Amount</label>
                            <TextInput type="number"
                                id="amount" name="amount"
                                value={props.journalVoucherDetails.amount}
                                handleChange={(event) => props.handleChange(event, "amount")}
                                className={props.validState?.error?.amount !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className="input-grp">
                            <label>Reference no</label>
                            <TextInput type="text" id="refNo" name="refNo" value={props.journalVoucherDetails.refNo} handleChange={(event) => props.handleChange(event, "refNo")} className={props.validState?.error?.refNo !== undefined ? "error" : ""} />
                        </div>
                        <div className="input-grp col-span-2">
                            <label>Remarks</label>
                            <TextInput type="text" id="remarks" name="remarks" value={props.journalVoucherDetails.remarks} handleChange={(event) => props.handleChange(event, "remarks")} />
                        </div>
                    </div>
                    {/* <div className="item-inner grid grid-cols-4 gap-2.5 mb-3">
                        <div className="input-grp">
                            <label>CGST amt {props.journalVoucherDetails.taxtTypeName === 'INTRASTATE' && props.journalVoucherDetails.cgst > 0 ? `- ${props.journalVoucherDetails.cgst}` : ""}</label>
                            <TextInput type="number" id="cgstAmt" name="cgstAmt" value={props.journalVoucherDetails.cgstAmt} handleChange={(event) => props.handleChange(event, "cgstAmt")} className={props.validState?.error?.cgstAmt !== undefined ? "error" : ""} disabled />
                        </div>
                        <div className="input-grp">
                            <label>SGST amt {props.journalVoucherDetails.taxtTypeName === 'INTRASTATE' && props.journalVoucherDetails.sgst > 0 ? `- ${props.journalVoucherDetails.sgst}` : ""}</label>
                            <TextInput type="number" id="sgstAmt" name="sgstAmt" value={props.journalVoucherDetails.sgstAmt} handleChange={(event) => props.handleChange(event, "sgstAmt")} className={props.validState?.error?.sgstAmt !== undefined ? "error" : ""} disabled />
                        </div>
                        <div className="input-grp">
                            <label>IGST amt {props.journalVoucherDetails.igst > 0 ? props.journalVoucherDetails.taxtTypeName === 'INTRASTATE' ? "" : `-${props.journalVoucherDetails.igst}` : ""}</label>
                            <TextInput type="number" id="igstAmt" name="igstAmt" value={props.journalVoucherDetails.igstAmt} handleChange={(event) => props.handleChange(event, "igstAmt")} className={props.validState?.error?.igstAmt !== undefined ? "error" : ""} disabled />
                        </div>
                        <div className="input-grp">
                            <label>Net total</label>
                            <TextInput type="number" id="netTotal" name="netTotal" value={props.journalVoucherDetails.netTotal} handleChange={(event) => props.handleChange(event, "netTotal")} className={props.validState?.error?.netTotal !== undefined ? "error" : ""} disabled />
                        </div>
                    </div> */}
                    {/* <div className="item-inner grid grid-cols-4 gap-2.5 mb-3.5">
                        <div className="input-grp col-span-2">
                            <label>Remarks</label>
                            <TextInput type="text" id="remarks" name="remarks" value={props.journalVoucherDetails.remarks} handleChange={(event) => props.handleChange(event, "remarks")} />
                        </div>
                    </div> */}
                    <div className="btn-grp inline-flex gap-2.5">
                        <button className="update-btn btns" onClick={() => props.submitJournalVoucher()} disabled={props.isSaving}>{props.journalVoucherDetails.updateStatus === 1 ? "Update" : "Save"}</button>
                        <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                    </div>
                </div>
            </div>
        </ModalBasic>
    )
}